import React, { useEffect } from 'react';
import compose from 'lodash/fp/compose';
import styled from 'styled-components';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './style.css';
import { useLocation, Link } from 'react-router-dom';
import {
  withMail,
  withAccount,
  withTranslation,
  withUserDefaultSpace,
  withFormValidation,
} from '../../../hoc';
import { FormValidationContext } from '../../../hoc/Preload/FormValidation';
import {
  FormModal,
  Form,
  Input,
  // FileInput,
  Button,
  // TextArea,
  // TextEditor,
  RichTextEditor,
  // Editor,
  ButtonLink,
} from '../../../common/FormItems';
import { FileEarmark, XCircleFill } from 'react-bootstrap-icons';
import { setMsgInfo } from '../../../../actions';
import { useDispatch } from 'react-redux';
import { Icon, Popup } from 'semantic-ui-react';

const Wrapper = styled.div`
  .form-wrapper {
    padding: 20px;
  }

  .container {
    background: var(--admincat-color-grey-1);
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
  }
`;

const Flex = styled.div`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  justify-content: ${({ justifyContent }) => justifyContent || ''};
  align-items: ${({ alignItems }) => alignItems || ''};
  flex-wrap: wrap;
`;

const FileAvatar = styled.div`
  margin: 5px 5px;
  font-style: italic;
  font-size: 0.9rem;
  align-items: center;
  display: block;
  color: var(--admincat-color-grey-2);
  background: var(--admincat-color-grey-1),

  &:last-child {
    margin-top: 0;
  }
`;

Flex.displayName = 'Flex';

const InputSection = styled(Flex)`
  margin: 0;
`;

const StyledButtonLink = styled(ButtonLink)`
  span {
    text-transform: uppercase;
  }
`;

const InputWrapper = styled(Flex)`
  margin-right: 5px;
  margin-bottom: 0px;
  justify-content: flex-start;
  max-width: 100%;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 0px;
  > div {
    flex: 1;
    min-width: 0;
  }
  textarea,
  input {
    min-width: 200px;
  }
`;


const Label = styled.label`
  color: var(--admincat-dark-color);
  font-size: 1rem;
  font-weight: 600;
  margin-right: 10px;
  align-self: start;
  width: 80px;
  flex-shrink: 0;
`;

const StyledButton = styled(Button)`
  && {
    // color: var(--admincat-dark-color) !important;
    text-transform: capitalize;
    width: 8.0625rem;
    height: 2.5rem;
    font-weight: 500;
    border-radius: 7px;
    transition: all ease-in-out 300ms;
    background: #4c81be;
    border: 1px solid #1d579b;
    box-sizing: border-box;
    font-style: normal;
    font-size: 1rem;
    line-height: 1rem;
    color: #ffffff;
    cursor: pointer;
    margin-right: 1rem;
  }
`;


const StyledRichTextEditor = styled(RichTextEditor)`
  // .rdw-editor-main {
  //   background: var(--admincat-color-grey-6);
  //   color: var(--admincat-color-grey-1);
  //   min-height: 200px;
  //   padding: 8px 12px;
  //   border-radius: 4px;
  // }

  .rdw-editor-toolbar {
    background-color: var(--admincat-color-grey-1);
    border: 1px solid var(--admincat-color-grey-2);
    border-radius: 4px;
    margin-bottom: 8px;
  }
`;

const mailFormSchema = {
  from_mail: {
    validation: 'required|email',
    message: {
      email: "Sender's email is invalid",
      required: "Sender's email is required",
    },
  },
  to_mail: {
    validation: 'required',
    message: {
      required: "Reciever's email is required",
    },
  },
  subject: {
    validation: 'required|min:3',
  },
  message: {
    validation: 'required|min:3',
    Link,
  },
};

// const MAX_SIZE_OF_ATTACHMENTS = 8485760; // this is the file size for attachments the django mail client can handle without crashing
const MAX_SIZE_SINGLE_DOCUMENT = 10485760; // Maximum size for a single document attachment (10MB)
const MAX_SIZE_OF_ATTACHMENTS = 26214400; // this is the file size for attachments the django mail client can handle without crashing (25MB)

const getFields = (formData) => {
  return [
    {
      type: 'email',
      name: 'from_mail',
      label: 'From',
      placeholder: 'Your email',
      disabled: true,
    },
    {
      type: 'text',
      name: 'to_mail',
      label: 'To',
      placeholder: 'example1@domain.com; example2@domain.com; example3@domain.com',
      autoComplete: 'off',
    },
    {
      type: 'text',
      name: 'subject',
      label: 'Subject',
      placeholder: 'Subject',
      autoComplete: 'off',
    },
    {
      type: 'textarea',
      name: 'message',
      label: 'Message',
      placeholder: 'Your message...',
    },
  ].map((data) => ({
    ...formData,
    ...data,
    value: formData[data.name],
  }));
};

const InputFieldType = {
  email: Input,
  text: Input,
  // text: (props) => <StyledInput {...props} autoComplete="off" />,
  textarea: StyledRichTextEditor,
};


  const Fields = (props) =>
    getFields({ ...props }).map(({ type, label, tr, ...rest }) => {
      const InputField = InputFieldType[type];
  
      return (
        <InputWrapper key={label}>
          <Label>{tr(label)}:</Label>
          <InputField 
            type={type} 
            {...rest} 
          />
        </InputWrapper>
      );
    });

const Compose = (props) => {
  const {
    openComposeForm,
    toggleComposeForm,
    onMailChange: onChange,
    mailFormData,
    sendMail,
    sendMailLoading,
    account: {
      user: { email: personalEmail },
    },
    userDefaultSpace: { space_detail },
    tr,
    basePath,
  } = props;
  const location = useLocation();
  const { selectedMail = null, type = 'compose', previousPath = '/dashboard/mail/inbox' } =
    location.state || {};
  const dispatch = useDispatch();

  const spaceEmail = space_detail && space_detail.email;

  const { validateForm } = React.useContext(FormValidationContext);

  const from_mail = spaceEmail || personalEmail;

  // Create a reference to the hidden file input element
  const hiddenFileInput = React.useRef(null);
  const [uploadedFiles, setUploadedFiles] = React.useState([]);

  // Add a new state to track file validation
  const [fileValidationError, setFileValidationError] = React.useState(false);
  const [wasFileValidationError, setWasFileValidationError] = React.useState(false);

  const handleFileUploadClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleFileChange = (event) => {
    const chosenFiles = Array.prototype.slice.call(event.target.files);
    handleUploadFiles(chosenFiles);
  };

  const validateFiles = (files) => {
    // Only newly picked File objects have a `.size`; entries carried over
    // from a reply/forward are plain `{ name, id, _existing: true }` stubs.
    const newFiles = (files || []).filter((file) => !file?._existing);

    // Convert bytes to MB for readable error messages
    const maxSingleSizeMB = Math.floor(MAX_SIZE_SINGLE_DOCUMENT / (1024 * 1024));
    const maxTotalSizeMB = Math.floor(MAX_SIZE_OF_ATTACHMENTS / (1024 * 1024));

    // Check individual file sizes first
    const oversizedFiles = newFiles.filter(
      (file) => file.size > MAX_SIZE_SINGLE_DOCUMENT,
    );
    if (oversizedFiles.length > 0) {
      setFileValidationError(true);
      setWasFileValidationError(true); // Set this when error occurs
      dispatch(
        setMsgInfo({
          success: false,
          msg: [
            `${tr(
              'one or more files exceed the maximum allowed file size of',
            )} ${maxSingleSizeMB} ${tr('MB')}`,
          ],
        }),
      );
      return false;
    }

    // Calculate total size
    const totalSize = newFiles.reduce((sum, file) => sum + file.size, 0);

    // Check total size
    if (totalSize > MAX_SIZE_OF_ATTACHMENTS) {
      setFileValidationError(true);
      setWasFileValidationError(true); // Set this when error occurs
      dispatch(
        setMsgInfo({
          success: false,
          msg: [
            `${tr(
              'the total size of the selected files exceeds the maximum allowed size of',
            )} ${maxTotalSizeMB} ${tr('MB')}`,
          ],
        }),
      );
      return false;
    }

    // All validations passed
    setFileValidationError(false);

    if (wasFileValidationError) {
      // Only show these messages if there was a previous error
      if (newFiles.length > 0) {
        dispatch(
          setMsgInfo({
            success: true,
            msg: [`${tr('files are now within the acceptable size limit')}`],
          }),
        );
      }
      setWasFileValidationError(false); // Reset after showing success message
    }

    if (newFiles.length === 0 && (files || []).length === 0) {
      dispatch(
        setMsgInfo({
          success: true,
          msg: [`${tr('all files have been removed')}`],
        }),
      );
    }

    return true;
  };

  const handleUploadFiles = (files) => {
    const uploaded = [...uploadedFiles];

    // Add new files if they don't already exist
    files.forEach((file) => {
      if (uploaded.findIndex((f) => f.name === file.name) === -1) {
        uploaded.push(file);
      }
    });

    // Always update the uploaded files array
    setUploadedFiles(uploaded);
    onChange({ target: { name: 'attachments', value: files } });

    // Validate after adding - this will set the error state and disable submit if needed
    if (validateFiles(uploaded)) {
      dispatch(
        setMsgInfo({
          success: true,
          msg: [`${tr('Files have been appended.')}`],
        }),
      );
    }
  };

  const removeFile = (fileName) => {
    const files = uploadedFiles.filter((file) => file.name !== fileName);
    const newFiles = files.filter((file) => !file._existing);
    const existingIds = files
      .filter((file) => file._existing)
      .map((file) => file.id)
      .filter(Boolean);

    setUploadedFiles(files);
    onChange({ target: { name: 'attachments', value: newFiles } });
    onChange({ target: { name: 'existing_attachments', value: existingIds } });
    validateFiles(files);
  };

  useEffect(() => {
    if (from_mail) {
      onChange({ target: { name: 'from_mail', value: from_mail } });
    }
    if (type === 'fwd') {
      onChange({
        target: { name: 'subject', value: `Fwd: ${selectedMail?.subject || ''}` },
      });
    }
    if (type === 'reply') {
      onChange({
        target: { name: 'subject', value: `Re: ${selectedMail?.subject || ''}` },
      });
      onChange({ target: { name: 'to_mail', value: selectedMail?.from_mail || '' } });
    }
    if ((type === 'reply' || type === 'fwd') && selectedMail) {
      // Carry over the source mail's attachments so they are re-attached to
      // the reply/forward. Inline images are embedded in the message body and
      // are handled on the backend.
      const existingAttachments = (selectedMail.attachments || []).filter(
        (att) => !att?.is_inline_mail_attachment && att?.id,
      );
      onChange({
        target: {
          name: 'existing_attachments',
          value: existingAttachments.map((att) => att.id),
        },
      });
      setUploadedFiles(
        existingAttachments.map((att) => ({
          name: att.filename || 'attachment',
          id: att.id,
          _existing: true,
        })),
      );
    }
    return () => null;
    // `type` and the source mail must be dependencies: /dashboard/mail/compose
    // does not unmount when you go from replying to one mail to replying to
    // another, so without them the form keeps the first mail's subject,
    // recipient and attachments.
  }, [spaceEmail, mailFormData.from_mail, type, selectedMail?.id]);

  return (
    <Wrapper>
      <div className="flex">
        <StyledButtonLink
          to="/dashboard/mail/inbox"
          className="option-btn"
          icon="angle double left"
          name="All Entries"
        />
      </div>
      <div className="row" style={{ margin: '20px 0' }}>
        <div className="col-md-8">
          <Form
            title="Compose Mail"
            open={openComposeForm}
            toggleForm={() => toggleComposeForm(null)}
            formData={mailFormData}
            validationSchema={mailFormSchema}
            renderActionButtons={() => null}

          >
            <Flex justifyContent="flex-end"></Flex>
            <InputSection flexDirection="column">
              <Fields
                {...mailFormData}
                selectedMail={selectedMail}
                tr={tr}
                onChange={onChange}
                // RichTextEditor seeds its body from selectedMail in its
                // constructor, so the key must change when the source mail
                // does - otherwise replying to a second mail keeps the first
                // mail's body.
                key={`${openComposeForm}-${type}-${selectedMail?.id ?? 'new'}`}
              />
              <Flex justifyContent="flex-end" alignItems="flex-end">
                <Popup
                  content={tr('Attach documents')}
                  size="mini"
                  trigger={
                    <Icon
                      name="attach"
                      onClick={handleFileUploadClick}
                      size="large"
                      style={{ marginRight: '1%', cursor: 'pointer' }}
                    />
                  }
                />
                <StyledButton
                  onClick={validateForm(sendMail)}
                  name="Send"
                  isLoading={sendMailLoading}
                  disabled={fileValidationError}
                  style={{
                    opacity: fileValidationError ? 0.5 : 1,
                    cursor: fileValidationError ? 'not-allowed' : 'pointer',
                  }}
                />
                <input
                  type="file"
                  ref={hiddenFileInput}
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                  multiple
                  accept=".pdf,.doc,.docx,.txt,.rtf,.jpg,.jpeg,.png,.gif,.xlsx,.xls,.csv,.ppt,.pptx"
                />
              </Flex>
            </InputSection>
          </Form>
        </div>

        {uploadedFiles.length > 0 && (
          <div className="col-md-4">
            <Form
              title={`${tr('Attachments')} (${uploadedFiles.length})`}
              renderActionButtons={null}
            >
              <Flex justifyContent="flex-start" flexDirection="column">
                {uploadedFiles.map((data) => (
                  <FileAvatar key={data?.name}>
                    <Icon name="attach" /> {data?.name}{' '}
                    <Popup
                      content={tr('Remove this file')}
                      size="mini"
                      trigger={
                        <Icon
                          name="times"
                          onClick={() => removeFile(data?.name)}
                          circular
                          inverted
                          color="red"
                          size="small"
                          style={{ cursor: 'pointer' }}
                        />
                      }
                    />
                  </FileAvatar>
                ))}
              </Flex>
            </Form>
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default compose(
  withMail,
  withAccount,
  withTranslation,
  withUserDefaultSpace,
  withFormValidation,
)(Compose);
